import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { MatchType } from 'src/types/domain.types';

interface MatchesResponse {
  matches: MatchType[];
}

const getMatches = (): Promise<MatchesResponse> => api.get(`/matches`);

export const useGetMatchesQuery = () => {
  return useQuery({
    queryKey: ['matches'],
    queryFn: getMatches,
    select: (data: MatchesResponse) => data.matches,
  });
};
